<mat-card appearance="outlined" style="max-width: 600px; margin: 4em auto;">
  <mat-toolbar>
    <h1>Login</h1>
  </mat-toolbar>
  <mat-card-content>
    <div>
      @for (p of providers.socialAuthServiceConfig?.providers; track p) {
        <p>
          @switch (p.id) {
            @case ('MICROSOFT') {
              <button class="microsoft" mat-stroked-button (click)="signInWith(p.id)">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
                  <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
                  <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
                  <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
                  <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
                </svg>
                <div>
                  mit Microsoft anmelden
                </div>
              </button>
            }
            @default {
              <button mat-stroked-button (click)="signInWith(p.id)">
                Über {{ p.id }} anmelden
              </button>
            }
          }
        </p>
      }
    </div>

    <mat-divider style="margin: 2em 0;"></mat-divider>

    <form #form="ngForm" class="form">

      @if (lastError) {
        <mat-error style="margin-bottom: 2em">{{ lastError }}</mat-error>
      }

      <mat-form-field appearance="outline">
        <mat-label>Username</mat-label>
        <input #name="ngModel" [(ngModel)]="data.login" autofocus autotrim matInput name="login" required>
        @if (name.hasError('required')) {
          <mat-error>
            Eingabe erforderlich
          </mat-error>
        }
        @if (form.hasError('invalidLogin')) {
          <mat-error>
            Login ungültig
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Password</mat-label>
        <input #password="ngModel" [(ngModel)]="data.password" matInput name="password" required type="password">
        @if (password.hasError('required')) {
          <mat-error>
            Field required
          </mat-error>
        }
      </mat-form-field>

      <mat-action-row>
        <button (click)="login()" [disabled]="form.invalid" color="primary" mat-raised-button>
          Login
        </button>
      </mat-action-row>
    </form>
  </mat-card-content>
</mat-card>

@if (waitPopup) {
  <div class="wait-popup">
    <div>
      <h2>Anmeldung im neuen Fenster, bitte warten</h2>
      <button mat-stroked-button (click)="waitPopup=false">abbrechen</button>
    </div>
  </div>
}
